import { FETCH_MASTER_SETTING, GET_MASTER_SETTING, UPDATE_MATER_SETTING } from 'actions/masterSetting';
import { call, put, takeLatest } from 'redux-saga/effects';
import { API } from '../api';

function* fetchMasterSetting(action) {
  try {
    const response = yield call(API.getAllMasterSetting, action.payload);
    yield put({ type: FETCH_MASTER_SETTING.SUCCESS, payload: response.data });
  } catch (e) {
    yield put({ type: FETCH_MASTER_SETTING.FAIL, payload: { error: e } });
  }
}

function* getMasterSettingById(action) {
  try {
    const response = yield call(API.getMasterSettingById, action.payload);
    yield put({ type: GET_MASTER_SETTING.SUCCESS, payload: response.data });
  } catch (e) {
    yield put({ type: GET_MASTER_SETTING.FAIL, payload: { error: e } });
  }
}

function* updateMasterSetting(action) {
  try {
    const response = yield call(API.updateMasterSetting, action.payload);
    yield put({ type: UPDATE_MATER_SETTING.SUCCESS, payload: response.data });
    action.cb && action.cb(response);
  } catch (e) {
    yield put({ type: UPDATE_MATER_SETTING.FAIL, payload: { error: e } });
  }
}

function* masterSetting() {
  yield takeLatest(FETCH_MASTER_SETTING.REQUEST, fetchMasterSetting);
  yield takeLatest(GET_MASTER_SETTING.REQUEST, getMasterSettingById);
  yield takeLatest(UPDATE_MATER_SETTING.REQUEST, updateMasterSetting);
}
export default masterSetting;
